"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledText = exports.ButtonWrapper = exports.PageNavigationWrapper = exports.FlexWrapper = exports.InlineBlockWrapper = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
const tokens_1 = require("../../../styles/tokens");
const Text_1 = require("../../Text/Text");
exports.InlineBlockWrapper = styled_components_1.default.div `
    display: inline-block;
    margin: 0 ${tokens_1.SIZES[1]};
`;
exports.FlexWrapper = styled_components_1.default.div `
    display: flex;
    flex-direction: column;
    gap: ${tokens_1.SIZES[3]};

    @media (min-width: ${tokens_1.BREAKPOINTS.sm}) {
        flex-direction: row;
        justify-content: space-between;
        align-items: center;
    }
`;
exports.PageNavigationWrapper = styled_components_1.default.div `
    display: flex;
    gap: ${tokens_1.SIZES[3]};
    align-items: center;
`;
exports.ButtonWrapper = styled_components_1.default.div `
    display: flex;
    gap: ${tokens_1.SIZES[2]};
`;
exports.StyledText = (0, styled_components_1.default)(Text_1.Text) `
    margin: 0;
`;
//# sourceMappingURL=Pagination.styles.js.map